import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'
import { handleLogIn } from '../utils/loginUtils'

const LoginPopup: React.FC<{
  onClose: () => void
  title: string
}> = ({
  onClose,
  title,
}) => {

  return (
    <Popup onClose={onClose}>
      <div className="title">
        {title}
      </div>
      <div className="buttonRow">
        <Button buttonStyle="green" onClick={handleLogIn}>
          Log In
        </Button>
        <Button
          buttonStyle="redStroke"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </Popup>
  )
}

export default LoginPopup